import React, { useState,useEffect } from "react";
import { Radio, Popup, DatetimePicker,Toast } from 'react-vant';
import './fillInformation.scss'
import arrow_left from '../../assets/update_new/arrow_left_white.svg';
import arrow_right from '../../assets/update_new/arrow_right.svg';
import buttonSignYellow from '../../assets/update_new/button_sign_yellow.svg'
import buttonSign from '../../assets/update_new/hello_button_sign.svg';
import { message } from "antd";
const FillInformation = ({ showFillInformation, confirmInfoData, country, city,clickBirthPlace }) => {
    const [gender, setGender] = useState('Male')
    const [bloodType, setBloodType] = useState('A')
    const [showBirthdate, setShowBirthdate] = useState(false)
    const [birthdate, setBirthdate] = useState(new Date(1999, 0, 1))
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const hideInfo = () => {
        setIsVisible(false);
        setTimeout(() => {
            showFillInformation(false);
        }, 300); // 与 CSS 动画持续时间一致
    };

    const BirthPlaceStatus = () => {
        clickBirthPlace(true);
    }
    //生日格式转换 前端展示
    const formatDateTime = (date) => {
        if (!date) return '';
        let dateobj = new Date(date);
        // 获取日期部分
        const day = String(dateobj.getDate()).padStart(2, '0');
        const month = String(dateobj.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始
        const year = dateobj.getFullYear();

        // 获取时间部分
        const hours = String(dateobj.getHours()).padStart(2, '0');
        const minutes = String(dateobj.getMinutes()).padStart(2, '0');
        const seconds = String(dateobj.getSeconds()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
    //生日格式转换 后端需要
    const formatDateTimeToBackend = (date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，所以加 1
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    const sendUserInfo = () => {
        if (!birthdate || !city) {
            message.info('Please fill in everything');
            return
        }
        const infoData = {
            gender: gender,
            bloodType: bloodType,
            birthday: formatDateTimeToBackend(birthdate),
        }
        confirmInfoData(infoData)
        hideInfo()
    }

    return (
        <div className={`fill_in_information_page_ ${isVisible ? 'visible' : ''}`}>
            <img className="fill_in_back" src={arrow_left} onClick={() => hideInfo()}></img>
            <div className="fill_in_div">
                <span className="fill_in_title">Gender</span>
                <Radio.Group className="radio_group" value={gender} onChange={(e) => setGender(e)} direction="horizontal" checkedColor="#F4A632" iconSize="14px" >
                    <Radio className="radio" name="Male">Male</Radio>
                    <Radio className="radio" name="Female">Female</Radio>
                    <Radio className="radio" name="Other">Other</Radio>
                </Radio.Group>
            </div>
            <div className="fill_in_div">
                <span className="fill_in_title">Blood Type</span>
                <Radio.Group className="radio_group" value={bloodType} onChange={(e) => setBloodType(e)} direction="horizontal" checkedColor="#F4A632" iconSize="14px" >
                    <Radio className="radio" name="A">A</Radio>
                    <Radio className="radio" name="B">B</Radio>
                    <Radio className="radio" name="O">O</Radio>
                    <Radio className="radio" name="AB">AB</Radio>
                </Radio.Group>
            </div>
            <div className="fill_in_div">
                <span className="fill_in_title">Birthday</span>
                <div className="fill_in_select" onClick={() => setShowBirthdate(true)}>
                    <span>{birthdate ? formatDateTime(birthdate) : 'MM / DD / YYYY hh:mm:ss'}</span>
                    <img style={{ marginLeft: '10px' }} src={arrow_right}></img>
                </div>
            </div>
            <div className="fill_in_div">
                <span className="fill_in_title">Birthplace</span>
                <div className="fill_in_select" onClick={BirthPlaceStatus}>
                    <span>{(country && city) ? city + " " + country : "Select your country and city"}</span>
                    <img style={{ marginLeft: '10px' }} src={arrow_right}></img>
                </div>
            </div>
            <div className="fill_in_tips_button">
                <span style={{ color: '000000bd', fontSize: '15px' }}><span style={{ color: '#000', fontSize: '16px', fontWeight: 'bold' }}>Tips:</span> Your privacy is protected in line with our policy, Please feel confident providing your information.</span>
                <div className="fill_in_send_button" onClick={sendUserInfo}>
                    <img src={buttonSign}></img>
                    <span style={{ marginLeft: '5px' }}>Send</span>
                </div>
            </div>
            <Popup
                visible={showBirthdate}
                style={{ height: 'auto' }}
                position='bottom'>
                <div className="pop_birthday_">
                    <div className="pop_birthday_top">
                        <span className="pop_birthday_title_text">Select Birthday</span>
                        <div>
                            <DatetimePicker
                                type='datetime'
                                minDate={new Date(1900, 0, 1)}
                                maxDate={new Date()}
                                value={birthdate}
                                onChange={(e) => setBirthdate(e)}
                            />
                        </div>
                        <div className="pop_birthday_confirm" onClick={() => setShowBirthdate(false)}>
                            <img src={buttonSignYellow}></img>
                            <span style={{ marginLeft: '5px' }}>Confirm</span>
                        </div>
                    </div>
                    <div className="pop_birthday_canel" onClick={() => setShowBirthdate(false)}>
                        <span>Cancel</span>
                    </div>
                </div>
            </Popup>
        </div>
    )
}
export default FillInformation;